<template>
  <v-layout wrap>
    <v-flex xs12 pb-0 my-4>
      <v-layout>
        <v-menu
          ref="menuDate"
          :close-on-content-click="false"
          v-model="menuDate"
          :return-value.sync="filters.dates"
          max-width="280px"
          min-width="280px"
          class="pr-4 mt-2"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-on="on"
              v-model="filters.dates"
              prepend-icon="mdi-calendar"
              :label="$t('common.fields.rentDate')"
              readonly
              hide-details
              class="balance-dates"
            >
              <template v-if="filters.dates.length === 2" #append>
                <v-icon @click.stop="filters.dates = []">mdi-close</v-icon>
              </template>
            </v-text-field>
          </template>
          <v-date-picker
            v-model="filters.dates"
            color="primary lighten-1"
            width="280"
            range
            :locale="$i18n.locale"
            :selected-items-text="filters.dates.toString()"
            :allowed-dates="allowedDates"
            @input="changeDate"
          ></v-date-picker>
        </v-menu>
      </v-layout>
    </v-flex>

    <v-flex xs12>
      <v-data-table
        ref="balance-table"
        id="driverTransactions"
        :items="filteredList"
        :headers="headers"
        :loading="isLoading"
        :loading-text="$t('common.table.dataIsLoading')"
        :server-items-length="2"
        :items-per-page="-1"
        :mobile-breakpoint="100"
        :height="tableHeight"
        class="table-custom driver-transactions small mb-4"
        hide-default-footer
      >
        <template slot="item" slot-scope="{ item }">
          <tr>
            <td>{{ item.num }}</td>
            <td>{{ item.number || '—' }}</td>
            <td>{{ item.brand_name || '—' }}</td>
            <td>{{ item.model_name || '—' }}</td>
            <td>{{ item.typeName || '—' }}</td>
            <td
              class="text-xs-left font-weight-bold"
              :class="{
                'red--text': !item.isNumberPositive,
                'green--text': item.isNumberPositive,
              }"
            >
              <div v-if="item.amount">
                <button class="edit-transaction" @click="onEditClick(item)">
                  {{ item.isNumberPositive ? '+' : '-' }}{{ item.amount }}
                </button>
              </div>
            </td>
            <td class="text-xs-left">
              <button class="edit-transaction" @click="onEditClick(item)">
                <div>{{ item.comment || '—' }}</div>
              </button>
            </td>
            <td class="text-xs-left">{{ item.createdAt }}</td>
            <td class="text-xs-left">{{ item.email || '—' }}</td>
          </tr>
        </template>
        <template slot="no-data">{{ $t('common.table.noData') }}</template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import calcTableHeight from '@/helpers/calcTableHeight';

export default {
  name: 'DriverTransactions',
  components: {},
  data() {
    return {
      tableHeight: 'auto',
      menuDate: false,

      filteredList: [],

      filters: {
        dates: [],
      },

      headers: [
        { text: this.$t('common.number'), sortable: false },
        { text: this.$t('auto.fields.number'), sortable: false },
        { text: this.$t('auto.fields.brand'), sortable: false },
        { text: this.$t('auto.fields.model'), sortable: false },
        { text: this.$t('common.table.transactionType'), sortable: false },
        {
          text: this.$t('driverTransactions.tableHeaders.amount'),
          sortable: false,
        },
        {
          text: this.$t('driverTransactions.tableHeaders.description'),
          sortable: false,
        },
        {
          text: this.$t('driverTransactions.tableHeaders.createdAt'),
          sortable: false,
        },
        {
          text: this.$t('driverTransactions.tableHeaders.user'),
          sortable: false,
        },
      ],
    };
  },
  watch: {
    /* eslint-disable */
    '$i18n.locale': async function() {
      await this.fetchDriverTransactions({
        page: this.paginationPage,
        driverId: this.$route.params.driverId,
      });
      this.$vuetify.goTo('#driverTransactions', 'easeInOutCubic');
    },
    'filters.dates': {
      handler(data) {
        this.setFilteredList(data);
      },
    },
    driverTransactions() {
      this.setFilteredList(this.filters.dates);
    },
  },
  computed: {
    ...mapGetters({
      driverTransactions: 'driver/getDriverTransactionsData',
      isLoading: 'global/getLoader',
      userId: 'global/getUserId',
    }),
  },
  methods: {
    ...mapActions({
      fetchDriverTransactions: 'driver/fetchDriverTransactionsData',
    }),
    ...mapMutations({
      setDriverTransactionsData: 'driver/setDriverTransactionsData',
    }),
    allowedDates(value) {
      const [from, to] = this.filters.dates;

      if (!from) return true;
      if (to) return true;

      const firstDate = new Date(from);
      const nextDate = new Date(value);

      return nextDate >= firstDate;
    },
    changeDate(val) {
      if (val.length === 2) {
        this.$refs.menuDate.save(this.filters.dates);
      }
    },
    setFilteredList(dates) {
      if (dates.length === 1) return;
      if (dates.length === 0) {
        this.filteredList = this.driverTransactions;
        return;
      }

      const filteredList = this.driverTransactions.filter((item) => {
        const from = new Date(dates[0]);
        const to = new Date(dates[1]);
        const itemDateStr = item.createdAt.split(' ')[0];
        const itemDate = new Date(itemDateStr);

        return itemDate >= from && itemDate <= to;
      });

      this.filteredList = filteredList.map((item, idx) => {
        return { ...item, num: idx + 1 };
      });
    },
    setDefaultMonth() {
      const today = new Date();
      const monthAgo = new Date();

      monthAgo.setDate(monthAgo.getDate() - 30);

      const formatNum = (v) => (v < 10 ? `0${v}` : v);
      const getDateString = (date) =>
        `${date.getFullYear()}-${formatNum(date.getMonth() + 1)}-${formatNum(
          date.getDate(),
        )}`;

      this.filters.dates = [getDateString(monthAgo), getDateString(today)];
    },
    getSectionName(key) {
      const names = {
        workdesk: this.$t('workersList.title'),
        fine: this.$t('fines.title'),
      };

      return names[key];
    },
    onEditClick(item) {
      if (!item.isEditable) {
        this.$emit('show-snack', {
          message: `${this.$t(
            'driverBalance.editWarning',
          )} "${this.getSectionName(item.sectionName)}"`,
          color: 'warning',
        });

        return;
      }

      const data = {
        isNumberPositive: item.isNumberPositive,
        data: {
          amount: Number(item.amount),
          comment: item.comment,
          id: item.id,
        },
      };

      this.$emit('edit-transaction', data);
    },
  },
  created() {
    this.setDefaultMonth();
  },
  mounted() {
    const table = this.$refs['balance-table'];
    this.tableHeight = calcTableHeight(table.$el) + 40;
  },
};
</script>

<style lang="scss">
.driver-transactions {
  .v-data-table-header {
    position: sticky;
    top: 0;
  }
}

.balance-dates {
  max-width: 250px;
  margin-bottom: 10px;
}

.edit-transaction {
  font-weight: 700;

  &:hover {
    opacity: 0.7;
    text-decoration: underline;
  }
}
</style>
